import { useEffect, useState } from 'react';

import type { SidepanelMode } from '../form-state';

export const useSidepanelMode = (
    initialMode: SidepanelMode,
    opportunityId: string | undefined,
): {
    readonly effectiveMode: SidepanelMode;
    readonly isCreate: boolean;
    readonly isEditing: boolean;
    readonly setMode: (next: 'edit' | 'view') => void;
} => {
    const [mode, setMode] = useState<'edit' | 'view'>(initialMode === 'edit' ? 'edit' : 'view');
    const modeResetKey = `${initialMode}:${opportunityId ?? ''}`;

    useEffect(() => {
        void modeResetKey;
        setMode(initialMode === 'edit' ? 'edit' : 'view');
    }, [initialMode, modeResetKey]);

    const isCreate = initialMode === 'create';
    const effectiveMode: SidepanelMode = isCreate ? 'create' : mode;

    return { effectiveMode, isCreate, isEditing: effectiveMode !== 'view', setMode };
};
